import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import LanguageSelector from '@/components/common/LanguageSelector'

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1
    }
  }
}

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94] as const
    }
  }
}

const ComingSoon = () => {
  const { t } = useTranslation()

  return (
    <main className="ambient-glow-bg relative min-h-screen content-center p-4">
      <div className="absolute top-4 right-4 md:top-6 md:right-6">
        <LanguageSelector />
      </div>

      <motion.div
        className="relative flex flex-col items-center gap-3 text-center w-full sm:w-4/5 lg:w-[60%] place-self-center"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.img
          src="/assets/omd-wallet.svg"
          alt="OMD Wallet"
          className="w-20 h-20"
          variants={itemVariants}
        />
        <motion.h1
          className="lg:text-2xl text-3xl font-extrabold secondary-gradient-text"
          variants={itemVariants}
        >
          OMD Wallet
        </motion.h1>

        <motion.div className="flex flex-col gap-2" variants={itemVariants}>
          <h1 className="text-4xl font-extrabold primary-gradient-text">
            {t('coming_soon.title')}
          </h1>
          <p className="text-text-main max-w-sm whitespace-pre-line">
            {t('coming_soon.desc')}
          </p>
        </motion.div>
      </motion.div>
    </main>
  )
}

export default ComingSoon
